import { Close } from "@mui/icons-material";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { Alert } from "react-bootstrap";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import * as Yup from "yup";
import { assets } from "../../assets";
import { useLoginMutation } from "../../redux/api/authApiSlice";
import { setCredentials } from "../../redux/features/auth/authSlice";
import "./Register.css";

export default function Login({ setIsRegistered, onHide }) {
  const togglePassword = (fieldId) => {
    const passwordField = document.getElementById(fieldId);
    if (passwordField.type === "password") {
      passwordField.type = "text";
    } else {
      passwordField.type = "password";
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [login, { isError, isSuccess, error, data }] = useLoginMutation();

  const initialValues = {
    email: "",
    password: "",
  };

  const userLoginSchema = Yup.object({
    email: Yup.string("ই-মেইল অথবা মোবাইল নাম্বার").required(
      "ই-মেইল অথবা মোবাইল নাম্বার"
    ),
    password: Yup.string()
      .required("পাসওয়ার্ড")
      .min(6, "কম্পক্ষে ৬ ডিজিটের পাসওয়ার্ড দিন"),
  });

  const {
    resetForm,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    isSubmitting,
    errors,
    touched,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: userLoginSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);

        await login({
          email: values.email,
          password: values.password,
        });
        setSubmitting(false);
      } catch (error) {
        setSubmitting(false);
      }
    },
  });
  useEffect(() => {
    if (isError) {
      toast.error(error?.data?.message);
    }
    if (isSuccess) {
      toast.success(data?.message);
      dispatch(setCredentials(data?.data));
      resetForm();
      onHide();
      if (data?.data?.user?.role_id !== 10) {
        navigate("/admin/dashboard");
      } else {
        navigate("/user-profile");
      }
    }
    // eslint-disabled-next-line
  }, [isError, isSuccess]);

  return (
    <div className="register-container">
      <div className="register-logo">
        <img src={assets.logo} alt="Logo" />
      </div>
      <div className="down-container">
        <div className="d-flex mb-2 justify-content-between align-items-center">
          <h6 className="m-0">লগইন করুন</h6>
          <Link onClick={() => onHide(false)}>
            <Close />
          </Link>
        </div>
        <div className="py-3 text-start">
          <Alert variant="info">
            <strong>গুরুত্বপূর্ণ নোটিশ:</strong> <br /> প্রিয় ব্যবহারকারী,{" "}
            <br /> আমরা আপনাদেরকে জানাতে চাই যে, আমাদের অ্যাপে নতুন আপডেট আনা
            হয়েছে এবং পুরনো সকল ব্যবহারকারীকে অবশ্যই পাসওয়ার্ড রিসেট করতে হবে।
            অতএব, দয়া করে পাসওয়ার্ড রিসেট সম্পন্ন করুন এবং নতুন পাসওয়ার্ড
            ব্যবহার করে লগইন করুন। <br />
            <br />
            <strong>যেভাবে পাসওয়ার্ড রিসেট করবেন:</strong> <br />
            ১। লগইন স্ক্রীনে থেকে "পাসওয়ার্ড ভুলে গেছেন ?" অপশনে ক্লিক করুন।{" "}
            <br />
            ২। আপনার রেজিস্টার্ড ই-মেইল আইডি দিন। <br />
            ৩। আপনার ই-মেইলে পাসওয়ার্ড রিসেট লিঙ্ক পাঠানো যাবে, লিঙ্কে ক্লিক
            করে নতুন পাসওয়ার্ড সেট করুন। <br />
          </Alert>
        </div>
        <form className="register-form text-start" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-12">
              <input
                type="text"
                name="email"
                placeholder="ই-মেইল অথবা মোবাইল নাম্বার"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                className={`form-control ${
                  errors.email && touched.email
                    ? "is-invalid"
                    : !errors.email && touched.email
                    ? "is-valid"
                    : ""
                }`}
              />
              {errors.email && touched.email ? (
                <small className="text-danger">{errors.email}</small>
              ) : (
                <div style={{ height: "24px" }}></div>
              )}
            </div>

            <div className="col-md-12">
              <div className="password-container">
                <input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="পাসওয়ার্ড"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  className={`form-control ${
                    errors.password && touched.password
                      ? "is-invalid"
                      : !errors.password && touched.password
                      ? "is-valid"
                      : ""
                  }`}
                />
                <span
                  className="show-password"
                  onClick={() => togglePassword("password")}
                >
                  👁️
                </span>
              </div>
              {errors.password && touched.password ? (
                <small className="text-danger">{errors.password}</small>
              ) : (
                <div style={{ height: "24px" }}></div>
              )}
            </div>
          </div>
          <button type="submit" className="col-md-12" disabled={isSubmitting}>
            {!isSubmitting ? "লগইন করুন" : <BeatLoader color="#fff" />}
          </button>
          <div className="d-flex mt-2 justify-content-between">
            <Link
              to="/forgot-password"
              onClick={onHide}
              className="forgot-password"
            >
              পাসওয়ার্ড ভুলে গেছেন ?
            </Link>
            <Link
              onClick={() => setIsRegistered(true)}
              className="register-link mr-2 pointer"
            >
              রেজিস্ট্রেশন করুন
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
